export default "__VITE_ASSET__hp3QLsnO__"